<template>
  <div class="container">
    <PullRefresh
      v-model="isLoading"
      success-text="刷新成功"
      :disabled="disabledPull || activityInfo.activityStatus !== 1"
      @refresh="onRefresh"
    >
      <div v-if="!isLive" class="pageNative flex_center">
        <div
          v-if="activityInfo.activityStatus === 0 && hasFetched"
          class="nativeStatus flex_center"
        >
          活动将于 {{ activityInfo.startTime }} 开始
        </div>
        <div class="nativeStatus flex_center" v-else>活动已结束</div>
      </div>
      <div v-else class="page">
        <!-- 头图 -->
        <div
          class="page_header bg_contain"
          :style="{
            backgroundImage: `url(${activityInfo.banner})`,
          }"
        >
          <!-- 已玩游戏数 -->
          <div
            class="page_header_child page_header_child_main page_header_total_value"
            :class="{ page_header_child_num: hasFetched }"
          >
            {{ activityInfo.playGameNum }}
          </div>
          <!-- 期望下载游戏数量 -->
          <div
            class="page_header_child page_header_child_main page_header_total_value"
            :class="{ page_header_child_one: hasFetched }"
          >
            1
          </div>
          <!-- 总价值 -->
          <div
            class="page_header_child page_header_child_main page_header_total_value"
            :class="{ page_header_child_value: hasFetched }"
          >
            {{ activityInfo.totalGiftValue }}
          </div>
        </div>
        <!-- 在玩游戏奖励列表 -->
        <div class="page_main">
          <div class="main_top mb_12">
            <div class="main_top_wrap flex_center">
              <div
                v-for="it in (activityInfo.levelVoList || [])"
                :key="it.level"
                class="main_top_item bg_contain"
                :class="{ main_top_item_active: curActiveLevel === it.level }"
                :style="{
                  backgroundImage: `url(${CDN_URL}/block${curActiveLevel === it.level ? '_active' : ''}.png)`
                }"
                @click="handleChangeLevelItem(it)"
              >
                <div class="main_top_item_num">
                  {{ getLevelStr(it) }}
                </div>
                <div class="main_top_item_value">
                  <div class="main_top_item_value_wrap flex_center wrapper">
                    <div class="main_top_item_digit text text_yellow pr_2" :data-text="it.giftValue"></div>
                    <div class="main_top_item_unit text" data-text="元"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="main_body">
            <div
              class="main_body_wrap bg_contain"
              :style="{
                backgroundImage: `url(${CDN_URL}/body_bg.png?v=1)`,
                backgroundSize: '100% 100%'
              }"
            >
              <div class="main_body_list wrapper">
                <div
                  v-for="it in curLevelInfo.giftContentList"
                  :key="it"
                  class="body_gift_item bg_contain fs_18 flex_center"
                  :style="{
                    backgroundImage: `url(${CDN_URL}/reward_bg.png?v=1)`,
                    backgroundSize: '100% 100%',
                    width: '100%',
                    height: '40px',
                  }"
                >
                  <div class="letter_spacing_2" style="display: flex;">
                    <span
                      v-for="(str, sIdx) in onSplitStringByParentheses(it)"
                      :key="(str + sIdx)"
                      class="text"
                      :class="{ text_greed: str.includes('(') }"
                      :data-text="onRemoveTag(str)"
                    ></span>
                  </div>
                </div>
              </div>
              <div class="main_body_download flex_center">
                <div
                  class="main_body_btn flex_center bg_contain"
                  :class="{ filter_grayscale: [2].includes(curLevelInfo.unlockStatus) }"
                  :style="{
                    width: '121px',
                    height: '36px',
                    backgroundImage: `url(${CDN_URL}/btn1.png?v=1)`,
                    backgroundSize: '100% 100%'
                  }"
                  @click="goGiftPage"
                >
                  <!-- 去领取、已领取 -->
                  {{ getBtnStr(curLevelInfo.unlockStatus) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 推荐游戏 -->
        <div class="page_recommend">
          <div class="recommend_title">
            <img :src="`${CDN_URL}/rec.png?v=1`" />
          </div>
          <div class="recommend_body">
            <div class="recommend_list">
              <div
                v-for="game in recommendList"
                :key="game.gameId"
                class="rec_item bg_contain"
                :style="{
                  backgroundImage: `url(${CDN_URL}/game_wrap.png?v=1)`,
                  backgroundSize: '100% 100%'
                }"
              >
                <div
                  class="rec_img bg_contain"
                  :style="{
                    backgroundImage: `url(${game.gameIcon})`
                  }"
                >
                </div>
                <div class="rec_info">
                  <div class="rec_title">{{ game.gameName }}</div>
                  <div class="rec_desc van-ellipsis scale09">{{ game.introduce }}</div>
                </div>
                <div
                  class="rec_btn bg_contain flex_center"
                  :style="{
                    backgroundImage: `url(${CDN_URL}/btn2.png?v=1)`,
                  }"
                  @click="handleClickGame(game)"
                >{{ 
                  game.packageName && installedPkgs.includes(game.packageName) 
                    ? '查看' : '下载'
                }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PullRefresh>
    <ActivityPopup
      :visible.sync="visible"
      v-bind="feedback"
      :headerStyle="{
        background: '#6600FF'
      }"
      confirmButtonColor="#6600FF"
      cancelButtonColor="#828282"
      @confirm="feedback.onSure"
      @cancel="feedback.onCancel"
    >

    </ActivityPopup>
  </div>
</template>
<script>
// 页面可能被 玩心BT 同时使用
// 来还愿了，真复刻了
import {
  setPageTitle, callHideToolbar, isInstalledPackage,
  jumpToNative, setRightTxt, clickRightTxt, toLogin,
} from "@/bridge/AppJsBridge";
import EventTrack from '@/mixins/eventTrack'
import AvoidFirstActivate from '@/mixins/avoidFirstActivate'
import { CDN_URL_1 } from "@/config";
import { PullRefresh } from "vant";
import ActivityPopup from '@/components/btBox/ActivityPopup.vue';
import {
  getGameTransferHomeApi, getGameTransferRecommendListApi,
} from '@/apis/btBoxActivity'

const LOCK_STATUS_MAP = new Map([
  [0, '点我下载领取'],
  [1, '去领取'],
  [2, '已领取'],
])

export default {
  components: {
    PullRefresh,
    ActivityPopup,
  },
  mixins: [EventTrack, AvoidFirstActivate],
  data () {
    return {
      CDN_URL: CDN_URL_1 + '/box_game_transfer',
      isLoading: false,
      disabledPull: false,
      hasFetched: false,
      activityInfo: {
        name: '',
        activityStatus: 2
      },
      feedbackType: 0,
      visible: false,
      recommendList: [],
      curActiveLevel: 1, // 当前选中的 level
      touchedLevelInfo: {}, // 记录用户点击过的 level 信息
      installedPkgs: [],
      levelGap: 0,
      curGameInfo: {},
    }
  },
  computed: {
    isWx () {
      return this.$route.query.app * 1 !== 1
    },
    isLive () {
      if (!this.hasFetched) return true
      if (!this.activityInfo.activityId && this.hasFetched) return false
      return this.activityInfo.activityStatus === 1
    },
    curLevelInfo () {
      const levelVoList = this.activityInfo.levelVoList || []
      const curLevel = levelVoList.find(it => it.level === this.curActiveLevel)
      return curLevel || { giftContentList: [] }
    },
    trackActInfo ()  {
      return JSON.stringify({
        activity_id: this.activityInfo.activityId,
        activity_name: this.activityInfo.name,
      })
    },
    actId () {
      return this.$route.query.id
    },
    feedback () {
      return this.feedbackMap[this.feedbackType]
    },
    feedbackMap () {
      return [
        {
          title: '会场未解锁',
          message: [`再下载${this.levelGap}款游戏即可解锁`],
          confirmButtonText: '去下载',
          onSure: () => {
            const { level, giftValue } = this.touchedLevelInfo
            this.triggerVisible(false)
            this.scrollToRecommend()
            this.eventTrack({
              event: "game_transfer_button",
              event_field: this.getTrackInfo({
                level,
                gift_value: giftValue,
                type: 1,
              }),
            })
          },
          onCancel: () => {
            this.triggerVisible(false)
          }
        },
        {
          title: '等级不符',
          message: ['您有更高等级福利可领取'],
          confirmButtonText: '我知道了',
          onSure: () => {
            this.triggerVisible(false)
          },
          onCancel: () => {
            this.triggerVisible(false)
          }
        },
        {
          title: '提示',
          message: [
            '已有游戏角色',
            '下载后无法晋升活动等级, 是否继续下载'
          ],
          confirmButtonText: '继续下载',
          cancelButtonText: '取消',
          showCancelButton: true,
          onSure: () => {
            const { gameId, gameName } = this.curGameInfo
            this.triggerVisible(false)
            this.handleGoGameDetail()
            this.eventTrack({
              event: "game_transfer_cancel_go_on_button",
              event_field: this.getTrackInfo({
                type: 2,
              }),
              appkey: gameId,
              appName: gameName,
            })
          },
          onCancel: () => {
            const { gameId, gameName } = this.curGameInfo
            this.triggerVisible(false)
            this.eventTrack({
              event: "game_transfer_cancel_go_on_button",
              event_field: this.getTrackInfo({
                type: 1,
              }),
              appkey: gameId,
              appName: gameName,
            })
          }
        },
      ]
    },
  },
  activated () {
    setRightTxt('活动规则');
  },
  // beforeRouteEnter: (to, from, next) => {
  //   callHideToolbar(true)
  //   next()
  // },
  // beforeRouteLeave: (to, from, next) => {
  //   callHideToolbar(false)
  //   next()
  // },
  methods: {
    init (f) {
      this.getRecommendGames()
      return this.getActInfo(f).then(res => {
        setPageTitle(this.activityInfo.name)
        this.setHeaderContent()
        this.eventTrack({
          event: 'game_transfer_page',
          event_field: this.getTrackInfo({
            play_num: this.activityInfo.playGameNum,
          }),
        })
      })
    },
    getActivityInfo () {
      this.init()
    },
    onRefresh () {
      this.init().finally(res => {
        setTimeout(() => {
          this.isLoading = false
        }, 500)
      })
    },
    // 获取活动详情
    getActInfo (isInit = true) {
      return getGameTransferHomeApi({
        activityId: this.actId,
      }, !this.isWx).then(res => {
        this.activityInfo = res.data || {
          activityId: '',
          activityStatus: 3,
          banner: "",
          defaultLevelTab: "",
          initPlayGameNum: 0,
          levelVoList: [],
          name: "",
          playGameNum: 0,
          startTime: "2022-01-01",
          totalGiftValue: 0,
        }
        if (isInit) {
          this.curActiveLevel = res.data.defaultLevelTab
          this.$nextTick(() => {
            this.touchedLevelInfo = this.curLevelInfo
          })
        }
      })
      .catch((error) => {
        let errorInfo = error.response;
        const { data } = errorInfo;
        if (data && data.code === 401) {
          toLogin("/loginKey/LoginByKeyPhoneActivity");
        }
        const { code, msg } = error
        // (94002, "活动已下架")
        // (94001, "该福利列表已下架"),
        if ([94001, 94002].includes(code)) {
          return
        }
        this.$toast.fail(msg)
      })
      .finally(() => {
        this.hasFetched = true
      })
    },
    getRecommendGames () {
      this.installedPkgs = []
      getGameTransferRecommendListApi({
        activityId: this.actId,
      }, !this.isWx).then(res => {
        this.recommendList = res.data || []
        const sourcePkgs = this.recommendList.map(it => it.packageName).join(',')
        console.log('sourcePkgs', sourcePkgs)
        isInstalledPackage(sourcePkgs, res => {
          this.installedPkgs = res.split(',').filter(it => it)
          console.log('has Installed', this.installedPkgs)
          this.onSortGames()
        })
      })
    },
    // 将推荐游戏排序
    onSortGames () {
      // 已安装的游戏排在后面
      this.recommendList.sort((a, b) => {
        if (this.installedPkgs.includes(a.packageName)) {
          if (this.installedPkgs.includes(b.packageName)) {
            return a.sort - b.sort
          }
          return 1
        } else if (this.installedPkgs.includes(b.packageName)) {
          if (this.installedPkgs.includes(a.packageName)) {
            return a.sort - b.sort
          }
          return -1
        } else {
          return a.sort - b.sort
        }
      })
    },
    goGiftPage () {
      const { unlockStatus, levelId, level, giftValue } = this.curLevelInfo
      if (unlockStatus === 2) return
      if (unlockStatus === 0) {
        this.scrollToRecommend()
        return
      }
      if (!(this.actId && levelId)) return
      this.eventTrack({
        event: "game_transfer_button",
        event_field: this.getTrackInfo({
          level,
          gift_value: giftValue,
          type: 2,
        }),
      })
      this.$router.push({
        name: 'box.gameTransfer.game',
        query: {
          id: this.actId,
          level: levelId,
          lev: level,
          name: this.activityInfo.name,
          app: this.isWx ? 0 : 1,
        }
      })
    },
    handleChangeLevelItem (it) {
      if (this.curActiveLevel === it.level) return
      const { level, startNum, unlockStatus, giftValue, endNum } = it
      this.touchedLevelInfo = it
      this.levelGap = startNum - this.activityInfo.playGameNum
      const hasOverLevel = this.activityInfo.playGameNum >= endNum
      this.eventTrack({
        event: "game_transfer_level_navigation",
        event_field: this.getTrackInfo({
          level,
          gift_value: giftValue
        }),
      })
      if (this.levelGap > 0) {
        this.triggerVisible(true, 0)
        this.eventTrack({
          event: "game_transfer_pop",
          event_field: this.getTrackInfo({
            level,
            gift_value: giftValue,
            type: 2,
          }),
        })
        return
      }
      if (this.levelGap < 0 && unlockStatus === 0 && hasOverLevel) {
        this.triggerVisible(true, 1)
        this.eventTrack({
          event: "game_transfer_pop",
          event_field: this.getTrackInfo({
            level,
            gift_value: giftValue,
            type: 1,
          }),
        })
        return 
      }
      this.curActiveLevel = level
    },
    // 点击 下载/查看按钮
    handleClickGame (game) {
      this.curGameInfo = game
      const { play, gameId, gameName } = game
      const hasInstalled = this.installedPkgs.includes(game.packageName)
      this.eventTrack({
        event: "game_transfer_down_view_button",
        event_field: this.trackActInfo,
        appkey: gameId,
        appName: gameName,
      })
      // 如果未下载且有市场包在玩记录，给出弹窗提示
      if (play && !hasInstalled) {
        this.eventTrack({
          event: "game_transfer_down_pop",
          event_field: this.trackActInfo,
          appkey: gameId,
          appName: gameName,
        })
        this.triggerVisible(true, 2)
        return
      }
      this.handleGoGameDetail(game)
    },
    // 跳转原生页面     
    handleGoGameDetail () {
      const { gameId } = this.curGameInfo
      const data = {
        routePath: "/main/game/GameDetailActivity",
        fromPageType: this.isWx ? 57 : 40, // 数据归因
        extraParams: gameId,
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },
    getBtnStr (status) {
      return LOCK_STATUS_MAP.get(status)
    },
    triggerVisible (v, type) {
      if (type !== undefined) {
        this.feedbackType = type
      }
      this.visible = v
    },
    getLevelStr (it) {
      const { startNum, endNum } = it
      if (startNum === endNum) return startNum
      if (endNum >= 9999) return `≥${startNum}`
      return `${startNum}-${endNum}`
    },
    /**
     * @input hello(world)example(test)
     * @output ['hello', '(world)', 'example', '(test)']
     */
    onSplitStringByParentheses (str) {
      const reg = str.match(/[^()]+|\([^)]+\)/g)
      return reg
    },
    /**
     * @input (world)
     * @output world
     */
    onRemoveTag (str) {
      return str.replace(/[()]/g, '')
    },
    scrollToRecommend () {
      const el = document.querySelector('.page_recommend')
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
    },
    // 设置顶部内容
    setHeaderContent() {
      setRightTxt("活动规则");
      clickRightTxt(() => {
        this.eventTrack({
          event: "game_transfer_rule_button",
          event_field: this.trackActInfo,
        });
        this.$router.push({
          name: this.isWx ? `box.actPlaceRule` : `box.btActRule`,
          params: {
            type: this.isWx ? 25 : 19,
          },
        });
      });
    },
    getTrackInfo (params = {}) {
      return JSON.stringify({
        activity_id: this.activityInfo.activityId,
        activity_name: this.activityInfo.name,
        ...params,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import "./style.scss";
.pageNative {
  width: 100vw;
  height: 100vh;
}
</style>